import { Tooltip } from 'antd';
import { FlaskConical } from 'lucide-react';

export function BetaTag({ asText, className }: { asText?: boolean; className?: string }) {
    return (
        <Tooltip
            className="cursor-help"
            classNames={{
                root: 'min-w-80 shadow-lg',
            }}
            color="var(--color-bg-elevated)"
            title={
                <div className="p-4">
                    <div className="mb-2.5 flex items-center gap-2">
                        <div className="flex h-7 w-7 items-center justify-center rounded-md bg-info-100 dark:bg-info-900/30">
                            <FlaskConical className="h-4 w-4 text-info-500" />
                        </div>
                        <span className="font-semibold text-foreground text-sm">Beta Feature</span>
                    </div>
                    <p className="m-0 text-muted-foreground text-sm leading-relaxed">
                        You have been given early access to a new feature that is still being tested. We welcome your
                        feedback, whether positive or negative, and suggestions for improvement.
                    </p>
                    <a
                        href="mailto:support@getcurium.com"
                        className="mt-3 inline-flex items-center gap-1 font-medium text-info-500 text-sm transition-colors hover:text-info-600"
                    >
                        Email us at support@getcurium.com
                    </a>
                </div>
            }
        >
            {asText ? (
                'BETA'
            ) : (
                <span
                    className={`inline-flex size-5 items-center justify-center rounded-md bg-info-500 text-white ${className ?? ''}`}
                    // `aria-label` is only valid on an element with a role; a bare <span> drops it
                    // (axe `aria-prohibited-attr`). The chip is an icon standing in for the word "beta".
                    role="img"
                    aria-label="Beta feature"
                >
                    <FlaskConical className="size-3" />
                </span>
            )}
        </Tooltip>
    );
}
